import axios from 'axios'
import _get from 'lodash/get'
import isString from 'lodash/isString'
import Base from './Base'
import routingMixin from '@/utils/mixins/routingParams'

const authStore = {
  identifier: '',
  password: '',
  filled: {
    identifier: false,
    password: false,
  },
  errorMessage: false, // false if all normal, string if smthg happend
  successMessage: false,
  errored: {
    identifier: false,
    password: false,
  },
  loading: false,
}

// authStore.errorMessage = 'Adsa.sadas.dasd'

export default {
  mixins: [routingMixin],
  methods: {
    // call before redirect (after login, register, etc.)
    resetViewStore() {
      authStore.identifier = ''
      authStore.password = ''
    },
    checkAnimation(field, e) {
      if (e.animationName == 'onAutoFillStart') {
        this.filled[field] = true
      } else if (e.animationName == 'onAutoFillCancel') {
        this.filled[field] = false
      }
    },
    checkFilled(field, evnt) {
      const value = evnt.target.value
      this.filled[field] = isString(value) && value.length > 0
    },
    resetErrors(all = false) {
      if (all) this.errorMessage = false
      this.errored = {
        identifier: false,
        password: false,
      }
    },
    authFlow(res) {
      this.$store.commit('request/authorized/setToken', res.data.jwt)
      this.$store.commit('user/setUser', res.data.user)
      this._goBack()
    },
    onSubmit() {
      throw new Error('Not implemented!')
    },
    onError(err) {
      this.errorMessage = _get(
        err,
        'response.data.message[0].messages[0].message',
        false
      )

      let errorId = _get(err, 'response.data.message[0].messages[0].id', false)

      if (!errorId || (!this.errorMessage && err.message)) {
        this.errorMessage = err.message
        return
      }
      if (errorId == 'Auth.form.error.invalid') {
        this.errored = {
          identifier: true,
          password: true,
        }
      }
      if (errorId.indexOf('email') > -1) {
        this.errored.identifier = true
      }
      if (errorId.indexOf('password') > -1) {
        this.errored.password = true
      }
    },
    login() {
      this.loading = true
      this.resetErrors(true)
      return axios
        .post(`${process.env.VUE_APP_BACKOFFICE_URL}auth/local`, {
          identifier: this.identifier,
          password: this.password,
        })
        .then((res) => {
          this.authFlow(res)
        })
        .catch((err) => {
          this.onError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    signupTG(user) {
      this.loading = true
      this.resetErrors(true)
      return axios
        .post(`${process.env.VUE_APP_BACKOFFICE_URL}auth/tgregister`, {
          ...user,
        })
        .then((res) => {
          this.authFlow(res)
        })
        .catch((err) => {
          this.onError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    signup() {
      this.loading = true
      this.resetErrors(true)
      return axios
        .post(`${process.env.VUE_APP_BACKOFFICE_URL}auth/local/register`, {
          username: `local@${this.identifier}`,
          email: this.identifier,
          password: this.password,
        })
        .then((res) => {
          try {
            this.authFlow(res)
          } catch (error) {
            this.erroMessage(error)
          }
        })
        .catch((err) => {
          this.onError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    forgot() {
      this.loading = true
      this.resetErrors(true)
      return axios
        .post(`${process.env.VUE_APP_BACKOFFICE_URL}auth/forgot-password`, {
          email: this.identifier,
        })
        .catch((err) => {
          this.onError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePass() {
      this.loading = true
      this.resetErrors(true)
      return axios
        .post(`${process.env.VUE_APP_BACKOFFICE_URL}auth/reset-password`, {
          code: this.$route.params.code,
          password: this.password,
          passwordConfirmation: this.password,
        })
        .then((res) => {
          this.authFlow(res)
        })
        .catch((err) => {
          this.onError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  computed: {
    isAuthorized() {
      return isString(this.$store.state.auth.token)
    },
  },
  data() {
    return authStore
  },
  components: {
    'auth-base': Base,
  },
  i18n: {
    messages: {
      en: require('@/locales/auth/en.json'),
      ru: require('@/locales/auth/ru.json'),
    },
  },
}
